import { render, staticRenderFns } from "./SidAlign.vue?vue&type=template&id=e378da5c"
import script from "./SidAlign.vue?vue&type=script&lang=js"
export * from "./SidAlign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports